import {useAppDispatch, useAppSelector} from "../../../hooks/use-store";
import {Box, Button, HStack, Text, useToast} from "@chakra-ui/react";
import * as React from "react";
import {useState} from "react";
import {changePage, setIsLeftToRight} from "../../../store/reducers";
import {addMediaProducerNew, registerProducer} from "../../../data/api/Customer";
import {getData} from "../../../utils/Utils";
import {RegistrationResponseModel, SetImageModel} from "../../../data/model/Producer";

export const SignupPageFour = () => {
    const { currentPage, producer } = useAppSelector((state) => state.landing);
    const dispatch = useAppDispatch();
    const toast = useToast();

    const {
        email,
        name,
        description,
        website,
        address,
        phone,
        piva,
        referentEmail,
        referentName,
        referentSurname,
        referentPhone,
    } = producer || {};

    const [isSubmitting, setIsSubmitting] = useState(false);

    // Configurazione dei campi da mostrare
    const fields: { label: string; value?: string }[] = [
        { label: "Email", value: email },
        { label: "Nome azienda", value: name },
        { label: "Descrizione", value: description },
        { label: "Sito web", value: website },
        { label: "Indirizzo", value: address },
        { label: "Telefono", value: phone },
        { label: "Partita IVA", value: piva },
        { label: "Email di contatto", value: email },
        { label: "Nome del referente", value: referentName },
        { label: "Cognome del referente", value: referentSurname },
        { label: "Telefono del referente", value: referentPhone },
        { label: "Email referente", value: referentEmail },
    ];

    return (
        <Box overflowY={"auto"}>
            <Text
                color={"primary.400"}
                alignSelf={"start"}
                mt={"24px"}
                textAlign={"center"}
                fontSize={20}
            >
                Riepilogo
            </Text>

            {fields
                .filter((f) => f.value) // mostra solo i campi valorizzati
                .map((f, idx) => (
                    <HStack key={idx} mt={"24px"}>
                        <Text
                            color={"primary.400"}
                            alignSelf={"start"}
                            w={"184px"}
                            fontSize={16}
                        >
                            {f.label}
                        </Text>
                        <Text color={"black"} alignSelf={"start"} fontSize={16}>
                            {f.value}
                        </Text>
                    </HStack>
                ))}

            <Button
                variant={"primary"}
                isLoading={isSubmitting}
                mt={"48px"}
                onClick={() => {
                    setIsSubmitting(true);
                    producer &&
                    registerProducer(producer)
                        .then(async (response) => {
                            if (response) {
                                console.log("signup successfull");
                                dispatch(changePage(4));
                                const responseProducer =
                                    getData<RegistrationResponseModel>(response)?.producer;

                                const list: SetImageModel[] = [];
                                producer?.logoUpload?.file && list.push(producer.logoUpload);
                                producer?.imagesUpload?.forEach((value) => list.push(value));

                                for (const value of list) {
                                    value.file &&
                                    (await addMediaProducerNew(
                                        {
                                            type: "Producer",
                                            id: responseProducer?.id || "",
                                            isMain: value.isMain || false,
                                        },
                                        value.file
                                    ));
                                }
                            } else {
                                toast({
                                    title: "Si è verificato un errore",
                                    description:
                                        response ||
                                        "Qualcosa è andato storto. Riprova più tardi",
                                });
                            }
                        })
                        .finally(() => {
                            setIsSubmitting(false);
                        });
                }}
            >
                Conferma
            </Button>

            <Button
                variant={"tertiary"}
                {...(currentPage !== 0 && {
                    mb: "24px",
                })}
                mt={"8px"}
                onClick={() => {
                    dispatch(setIsLeftToRight(true));
                    dispatch(changePage((currentPage ?? 0) - 1));
                }}
            >
                Indietro
            </Button>
        </Box>
    );
};
